// define profile reducers.
import {
  krdetailConstants
} from '../constants/krdetails.constants';
const initialState = {
  metric: []
};
const updateOKRReducer = (state = initialState, action) => {

  switch (action.type) {
    case krdetailConstants.GET_UPDATE_KR_CONFIDENCE:
      //const index = state.metrics.findIndex(todo => todo.id !== action.payload);
      let metricIdToUpdate = action.data.metricId;

      state.userKrs.filter((e)=>{
        (e.metrics || []).forEach((f)=>{
          if(f.id === metricIdToUpdate) {
            f.confidence = action.data;
          }
        });        
      });      
      return state;
      default:
        return state;
  }
};

export default updateOKRReducer;